import { getCurrentDateLocal } from '@/utils/common';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface CheatSheetData {
  main?: Array<{
    id: string | number;
    quantity?: number;
    kids_name?: string;
    [key: string]: unknown;
  }>;
  side?: Array<{
    id: string | number;
    quantity?: number;
    kids_name?: string;
    [key: string]: unknown;
  }>;
  [code: string]:
    | {
        [lesson_code: string]: Array<{
          id?: string;
          am?: string;
          fd?: string;
          pm?: string;
          instructor_id_am?: number;
          instructor_id_fd?: number;
          instructor_id_pm?: number;
          [key: string]: unknown;
        }>;
      }
    | unknown;
}

export type CheatSheetStoreState = {
  // Data
  cheatSheetDate: string | null;
  cheatSheetType: string;
  cheatSheetData: CheatSheetData | null;
  setCheatSheetDate: (date: string | null) => void;
  setCheatSheetType: (type: string | null) => void;
  setCheatSheetData: (data: CheatSheetData) => void;
  resetCheatSheetStore: () => void;
};

type DailyRosterDataState = {
  cheatSheetDate: string | null;
  cheatSheetType: string;
  cheatSheetData: CheatSheetData | null;
};

const initialState: DailyRosterDataState = {
  cheatSheetDate: getCurrentDateLocal(),
  cheatSheetType: '',
  cheatSheetData: null
};

const useCheatSheetStore = create<CheatSheetStoreState>()(
  devtools(
    set => ({
      ...initialState,

      setCheatSheetDate: (date: string | null) => set({ cheatSheetDate: date }),

      setCheatSheetType: (type: string) => set({ cheatSheetType: type }),

      setCheatSheetData: (data: CheatSheetData) =>
        set({ cheatSheetData: data }),

      resetCheatSheetStore: () => set(initialState)
    }),
    {
      name: 'cheat-sheet-store'
    }
  )
);

export default useCheatSheetStore;
